import * as React from 'react';
import type { DocumentViewerContextValue } from './useDocumentViewer';

const DocumentViewerContext = React.createContext<DocumentViewerContextValue | null>(null);

export default DocumentViewerContext;
